import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import LoaderOverlay from '../../../1stlog-ui/src/components/LoaderOverlay'
import Trace from './Trace'
import { requestSearch } from '../Tariffs/requests'
import { getRecursiveTrace } from '../Tariffs/utils'

const Wrapper = styled.div`
  position: relative;
  background: #f3f7f9 !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
  margin-bottom: 5px;
  min-height: ${({ isLoading }) => (isLoading ? '80px' : '')};
`

const TariffTree = (props) => {
  const { trace: propTrace, initialZtn, ztn, mode, onTraceLoaded = lodash.noop } = props

  // if initialZtn is set: search only on mount
  // if ztn is set, search on every change

  const [isLoading, setIsLoading] = useState(false)
  const [searchTrace, setSearchTrace] = useState([])

  const loadSearch = async (query) => {
    try {
      setIsLoading(true)
      const data = await requestSearch({ mode, query })
      const item = getRecursiveTrace({
        targetZtn: query,
        tree: lodash.first(data)
      })
      setSearchTrace(item)
      onTraceLoaded(item)
    } catch (err) {
      console.error('Failed to load search tariff tree', err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (initialZtn) {
      loadSearch(initialZtn)
    }
  }, [])

  const trace = useMemo(() => {
    return propTrace || searchTrace
  }, [propTrace, searchTrace])

  if (lodash.isEmpty(trace) && !isLoading) {
    return null
  }

  return (
    <Wrapper isLoading={isLoading}>
      <LoaderOverlay isLoading={isLoading} ensureSize>
        <div>{i18n.t('tariffTree_is_loading', `Zolltarifbaum wird geladen...`)}</div>
      </LoaderOverlay>
      <Trace trace={trace} level={0} />
    </Wrapper>
  )
}

export default TariffTree
